export const FULL_MONTH_FORMAT = 'MMMM';
export const DAY_FORMAT = 'DD';
export const DAY_NAME_FORMAT = 'dddd';
export const DATE_FORMAT = 'DD.MM.YYYY';

export const MONTH_YEAR_FORMAT = 'MM.YYYY';
export const FULL_DAY_FORMAT = 'DD MMMM YYYY';
